import { BeautyProfilerAllure } from "../../../../types/BeautyProfilerAllure";
import { ProfilerProduct } from "../../../../types/ProfilerProduct";
import { BeautyProfilerAllureSection } from "./BeautyProfilerAllureSection";
import { MainFragranceCard } from "./MainFragranceCard";

type BeautyProfilerMainFragranceResultsProps = {
  setActiveTab: (tab: "fragrance" | "detailed") => void;
  topAllure: BeautyProfilerAllure | null;
  topFetiche: ProfilerProduct | null;
};

export const BeautyProfilerMainFragranceResults = ({
  setActiveTab,
  topAllure,
  topFetiche,
}: BeautyProfilerMainFragranceResultsProps) => {
  return (
    <div className="relative h-full w-full bg-[#FBF9F7] flex flex-col items-cente overflow-scroll">
      <img
        src={`/beauty-profiler/main-fragrances/${topFetiche?.id}.jpg`}
        alt={`/beauty-profiler/main-fragrances/${topFetiche?.id}.jpg`}
        className="absolute z-0 w-full  object-cover blur-[35px]"
      />
      <div className="flex flex-col w-full p-8 gap-9 relative items-center">
        <MainFragranceCard topFetiche={topFetiche} />
        <BeautyProfilerAllureSection
          topAllure={topAllure}
          onDiscoverClick={() => setActiveTab("detailed")}
        />
      </div>
    </div>
  );
};
